var smiBlock = smiBlock || {};
var templateMap = templateMap || [];
jQuery(function($) {
    var regex = /msie|Trident.*rv[ :]*11\./gi,
        isIE = regex.test(window.navigator.userAgent);

    var feedDomain, feedDir, defaultImageSrc;

    var blockDebug = document.location.search.indexOf('blockDebug=1') !== -1,
        blockCount = 0,
        noHeadingCount = 0,
        widgetRight = 1,
        loadedTemplates = [],
        usedInPage = [],
        storyCounts = [],
        feeds = [],
        feedPointer = [],
        fetchedTemplates = [],
        prevHeading, ad;

    switch(window.location.hostname) {
        case 'www.sonomanews.com' :
        case 'sit.stage.ew.srp.navigacloud.com' :
        case 'sit.everywarestarterkit.local' :
            feedDomain = 'sonomanews.com';
            feedDir = 'sit2018';
            defaultImageSrc = 'https://img.sonomanews.com/default.png';
            break;
        case 'www.petaluma360.com' :
        case 'pac.stage.ew.srp.navigacloud.com' :
        case 'pac.everywarestarterkit.local' :
            feedDomain = 'petaluma360.com';
            feedDir = 'pac2018';
            defaultImageSrc = 'https://img.petaluma360.com/default.png';
            break;
        case 'www.northbaybusinessjournal.com' :
        case 'nbbj.stage.ew.srp.navigacloud.com' :
        case 'nbbj.everywarestarterkit.local' :
            feedDomain = 'northbaybusinessjournal.com';
            feedDir = 'nbbj2018';
            defaultImageSrc = 'https://img.northbaybusinessjournal.com/default.png';
            break;
        case 'www.sonomacountygazette.com' :
        case 'scg.stage.ew.srp.navigacloud.com' :
        case 'scg.everywarestarterkit.local' :
            feedDomain = 'pressdemocrat.com';
            feedDir = 'pd2018';
            defaultImageSrc = 'https://img.sonomacountygazette.com/default.png';
            break;
        case 'www.laprensasonoma.com' :
        case 'lps.stage.ew.srp.navigacloud.com' :
        case 'lps.everywarestarterkit.local' :
            feedDomain = 'pressdemocrat.com';
            feedDir = 'pd2018';
            defaultImageSrc = 'https://img.laprensasonoma.com/default.png';
            break;
        default :
            feedDomain = 'pressdemocrat.com';
            feedDir = 'pd2018';
            defaultImageSrc = 'https://img.pressdemocrat.com/default.png';
            break;
    }

    smiBlock.adaptImages = function(el, forceAll) {
        adaptImages(el, forceAll);
    };

    smiBlock.do = function(block, blockData, onSuccess, onComplete) {
        doBlock(block, blockData, onSuccess, onComplete);
    };

    smiBlock.get = function(parent) {
        if(parent) parent = (typeof parent === 'string' || parent instanceof String) ? $(parent) : parent;
        else parent = $('body');

        parent.find('.dynamic-content-block, .tpl2022__build-block').not('.fetching').not('.rendered').first().each(function() {
            getThisBlock($(this), parent);
        });

        function getThisBlock(block, parent) {
            block.addClass('fetching');
            doBlock(block, block.data(), function() {
                block.addClass('rendered');
            }, function() {
                smiBlock.get(parent);
            });
        }
    };

    function adaptAllHeadlines() {
        $('[data-adapt-headlines], [data-stretch-headlines]').each(function() {
            var block = $(this).closest('.content-block, .dynamic-content-block, .tpl2022__build-block, .tpl2022__block');
            adaptHeadlines(block);
        });
    }

    function adaptHeadlines(block) {
        var adaptData = block.find('[data-adapt-headlines]').data('adapt-headlines');

        block.find('.story .story-heading h3, .tpl2022__headline h3').css({
            fontSize  : '',
            lineHeight: '',
            maxHeight : ''
        }).data('adapted', 0);

        if(adaptData) {
            var growUntilFit = function(toAdapt, adaptTo, adaptFrom, baseFontSize, prevAdaptToH) {
                if(toAdapt.is(':visible') && (adaptFrom.offset().top === adaptTo.offset().top)) {
                    var newFontSize = 0,
                        fontSize,
                        lineHeight,
                        lineHeightRatio,
                        maxHeight,
                        maxHeightFactor,
                        newMaxHeight;

                    toAdapt.data('adapted', 1);

                    if(adaptFrom.height() > (adaptTo.height() + 10)) {
                        fontSize = parseFloat(toAdapt.css('font-size'));
                        lineHeight = parseFloat(toAdapt.css('line-height'));
                        maxHeight = parseFloat(toAdapt.css('max-height'));
                        lineHeightRatio = (lineHeight / fontSize).toFixed(3);
                        toAdapt.css('line-height', lineHeightRatio);

                        if(!isNaN(maxHeight)) {
                            toAdapt.css('max-height', 'none');
                            if(adaptTo.height() > adaptFrom.height()) {
                                maxHeightFactor = maxHeight / lineHeight;
                                maxHeightFactor = parseInt(maxHeightFactor);
                                newMaxHeight = (lineHeightRatio * fontSize * (maxHeightFactor + 1)).toFixed(1);
                                toAdapt.css('max-height', newMaxHeight + 'px');
                            }
                        }

                        if(adaptTo.height() === prevAdaptToH) {
                            newFontSize = (fontSize + 1).toFixed(1);
                            toAdapt.css({maxHeight: 'none', fontSize: newFontSize + 'px'});

                            if(newMaxHeight !== 'undefined') {
                                newMaxHeight = (lineHeightRatio * newFontSize * maxHeightFactor).toFixed(1);
                                toAdapt.css('max-height', newMaxHeight + 'px');
                            }

                            if(adaptTo.height() > adaptFrom.height()) {
                                var cssHeight = isNaN(maxHeight) ? 'none' : maxHeight + 'px';
                                toAdapt.css({maxHeight: cssHeight, fontSize: fontSize + 'px'});
                                return false;
                            }
                        }

                        if(newFontSize < (baseFontSize * 1.3)) {
                            growUntilFit(toAdapt, adaptTo, adaptFrom, baseFontSize, adaptTo.height());
                        }
                    }
                }
            };

            $.each(adaptData.split('<=>'), function(i, v) {
                var adaptParts = v.split('->'),
                    adaptToSel = (typeof adaptParts[0] !== 'undefined') ? adaptParts[0] : null,
                    adaptFromSel = (typeof adaptParts[1] !== 'undefined') ? adaptParts[1] : null,
                    adaptTo, toAdapt, adaptFrom, baseFontSize;

                if(adaptToSel && adaptFromSel) {
                    adaptFrom = block.find(adaptFromSel);
                    adaptTo = block.find(adaptToSel);

                    if(adaptTo.length && adaptFrom.length) {
                        toAdapt = adaptTo.find('.story .story-heading h3, .tpl2022__headline h3');
                        toAdapt.css({fontSize: '', maxHeight: ''});
                        baseFontSize = parseFloat(toAdapt.css('font-size'));

                        growUntilFit(toAdapt, adaptTo, adaptFrom, baseFontSize, 0);
                    }
                }
            });
        }

        block.find('[data-stretch-headlines]').each(function() {
            var toStretchIn = $(this),
                maxStretchFactor = toStretchIn.data('stretch-headlines'),
                headlines = toStretchIn.find('.story .story-heading h3, .tpl2022__headline h3');

            if(headlines.length && maxStretchFactor) {
                var growUntilFit = function(h3, baseFontSize) {
                    var fontSize = parseFloat(h3.css('font-size')),
                        lineHeight = parseFloat(h3.css('line-height')),
                        maxHeight = parseFloat(h3.css('max-height')),
                        lineHeightRatio = (lineHeight / fontSize).toFixed(3),
                        fontSizeNew = (fontSize + 1).toFixed(1),
                        h3Rows, h3RowsNew;

                    if(isNaN(maxHeight)) {
                        h3.css({maxHeight: 'none', lineHeight: lineHeightRatio});
                        h3Rows = (h3.height() / (lineHeightRatio * fontSize)).toFixed(0);
                        h3.css('font-size', fontSizeNew + 'px');
                        h3RowsNew = (h3.height() / (lineHeightRatio * fontSizeNew)).toFixed(0);
                        if(h3Rows === h3RowsNew) {
                            if(fontSizeNew <= (baseFontSize * maxStretchFactor)) {
                                return growUntilFit(h3, baseFontSize);
                            }
                        }
                        h3.css('font-size', fontSize + 'px');
                    }
                    return false;
                };

                $.each(headlines, function() {
                    var h3 = $(this),
                        hasAdapted = h3.data('adapted') === 1,
                        baseFontSize = parseFloat(h3.css('font-size'));

                    if(!hasAdapted) {
                        growUntilFit(h3, baseFontSize);
                    }
                });
            }
        });
    }

    function adaptImages(el, forceAll) {
        if(el) el = (typeof el === 'string' || el instanceof String) ? $(el) : el;
        else el = $('body');

        /** BEGIN: new 2022 (is2022) */
        el.find('.tpl2022__image img[data-src]:visible').each(function() {
            var image = $(this);

            if(forceAll || isAboveBottomOfViewport(image)) {
                var imageSrc = image.data('src');
                image.attr('src', imageSrc);
                image.attr('srcset', image.data('srcset'));
                image.attr('sizes', image.data('sizes'));

                image.removeAttr('data-src');
                image.removeAttr('data-srcset');
                image.removeAttr('data-sizes');

                if(isIE) {
                    var fakeImage = image.parent('a');
                    if(fakeImage.length) {
                        fakeImage.addClass('ie-polyfill');
                        fakeImage.css('background-image', 'url(' + imageSrc + ')');
                    }
                }
            }
        });
        /** END: new 2022 */

        el.find('.story-thumbnail img.not-adapted:visible').each(function() {
            var image = $(this);

            if(forceAll || isAboveBottomOfViewport(image)) {
                var width = image.width(),
                    srcWidth = image.data('src-width');

                if(width > srcWidth) {
                    var thumbSrc = image.data('src-thumb'),
                        smallSrc = image.data('src-small'),
                        mediumSrc = image.data('src-medium'),
                        largeSrc = image.data('src-large'),
                        jumboSrc = image.data('src-jumbo'),
                        imageSrc;

                    if(thumbSrc && width <= 150) {
                        imageSrc = thumbSrc;
                        srcWidth = 150;
                    } else if(smallSrc && width <= 300) {
                        imageSrc = smallSrc;
                        srcWidth = 300;
                    } else if(mediumSrc && width <= 768) {
                        imageSrc = mediumSrc;
                        srcWidth = 768;
                    } else if(largeSrc && width <= 1024) {
                        imageSrc = largeSrc;
                        srcWidth = 1024;
                    } else {
                        if(jumboSrc) {
                            imageSrc = jumboSrc;
                        } else if(largeSrc) {
                            imageSrc = largeSrc;
                        } else if(mediumSrc) {
                            imageSrc = mediumSrc;
                        } else if(smallSrc) {
                            imageSrc = smallSrc;
                        } else if(thumbSrc) {
                            imageSrc = thumbSrc;
                        } else {
                            imageSrc = defaultImageSrc;
                        }
                        srcWidth = 1200;
                    }

                    if(imageSrc) {
                        image.attr('src', imageSrc).data('src-width', srcWidth);

                        if(isIE) {
                            var fakeImage = image.parent('a');
                            if(fakeImage.length) {
                                fakeImage.addClass('img-polyfill');
                                fakeImage.css('background-image', 'url(' + imageSrc + ')');
                            }
                        }

                        if(srcWidth === 1200) {
                            image.removeClass('not-adapted');
                        }
                    }
                }
            }
        });
    }

    /*
        function adaptStories() {
            var adaptUsedInPage = [], iterations = [], adaptPointer = [];
            adaptUsedInPage = usedInPage.slice(0);

            console.log('here1');

            $("[data-adapt]").each(function() {
                var toAdapt = $(this),
                    adaptData = toAdapt.data('adapt');

                console.log('here2:', toAdapt);

                toAdapt.find('.height-adapted').remove();

                if(adaptData !== 'undefined' && adaptData) {
                    var block = toAdapt.closest(".content-block, .dynamic-content-block, .tpl2022__build-block"),
                        cacheKey = block.data('cache-key'),
                        adaptParts = adaptData.split('->'),
                        adaptFromSel = (typeof adaptParts[1] !== 'undefined') ? adaptParts[1] : null,
                        adaptToSel = (typeof adaptParts[0] !== 'undefined') ? adaptParts[0] : null,
                        adaptFrom, adaptTo, adaptFromH, adaptToH;

                    if(cacheKey !== 'undefined' && cacheKey && adaptFromSel && adaptToSel) {
                        if(typeof iterations[cacheKey] === 'undefined') {
                            iterations[cacheKey] = 1;
                            adaptPointer[cacheKey] = feedPointer[cacheKey];
                        } else {
                            iterations[cacheKey]++;
                        }

                        adaptFrom = block.find(adaptFromSel);
                        adaptTo = (toAdapt.is(adaptToSel)) ? toAdapt : toAdapt.closest(adaptToSel);

                        if(adaptTo.length && adaptFrom.length) {
                            fillHeight();

                            function fillHeight() {
                                if(toAdapt.is(':visible') && adaptFrom.length && adaptTo.length && (adaptFrom.offset().top === adaptTo.offset().top)) {
                                    adaptFromH = adaptFrom.height();
                                    adaptToH = adaptTo.height();

                                    if(adaptFromH > (adaptToH + 30)) {
                                        var ts = '#tpl-story';
                                        if(typeof loadedTemplates[ts] === 'undefined' && loadedTemplates[ts] !== false) {
                                            template = $(ts);
                                            if(template.length) {
                                                loadedTemplates[ts] = Template7(template.html()).compile();
                                            } else {
                                                loadedTemplates[ts] = false;
                                            }
                                        }
                                        if(loadedTemplates[ts]) {
                                            var storyObj = getFirstUnusedStory();
                                            if(storyObj && !$.isEmptyObject(storyObj)) {
                                                var story = $(loadedTemplates[ts](storyObj));
                                                story.addClass('height-adapted').appendTo(toAdapt);
                                                if(adaptFromH > (adaptToH + 30)) {
                                                    fillHeight();
                                                }
                                                var halfStory = story.height() / 2;
                                                if((adaptFromH - adaptToH) > halfStory) {
                                                    adaptPointer[cacheKey]--;
                                                    story.remove();
                                                }
                                            }

                                            function getFirstUnusedStory() {
                                                var validObj = feeds[cacheKey].stories[adaptPointer[cacheKey]++];
                                                if(typeof validObj === 'object') {
                                                    if($.inArray(validObj.cmsId, adaptUsedInPage) !== -1)
                                                        return getFirstUnusedStory();

                                                    adaptUsedInPage.push(validObj.cmsId);
                                                    return validObj;
                                                }
                                                return false;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            });
        }
    */

    function buildWidget(widgetSettings) {
        var slotSize = widgetSettings.size,
            widgetVar = 'widgetQueue',
            forceType = (typeof widgetSettings.forceType !== 'undefined') ? widgetSettings.forceType : false,
            widget, thisWidget, widgetType, toShow;

        if(typeof window[widgetVar] === 'undefined')
            return false; // skip widget area

        if(typeof window[widgetVar][slotSize] === 'undefined')
            return false; // skip widget area

        if(!window[widgetVar][slotSize].length)
            return false; // skip widget area

        if(forceType) {
            thisWidget = window[widgetVar][slotSize].find(function(slot, index, array) {
                if(slot.type === forceType) {
                    array.splice(index, 1);
                    return true;
                }
            });
        } else {
            thisWidget = window[widgetVar][slotSize].shift();
        }

        if(typeof thisWidget !== 'object')
            return false; // skip widget area

        if(typeof thisWidget.type !== 'string')
            return false; // skip widget area

        widgetType = thisWidget.type;

        toShow = thisWidget.show || {};

        var theBody = $('body'),
            isAdFree = theBody.hasClass('ad-free'),
            isAdLite = theBody.hasClass('ad-lite'),
            isAd = widgetType === 'ad',
            widgetHeading = thisWidget.heading,
            showIfAdFree = typeof toShow.adFree !== 'undefined' && parseInt(toShow.adFree) === 1,
            showIfAdLite = typeof toShow.adLite !== 'undefined' && parseInt(toShow.adLite) === 1;

        // whether to serve the widget or non-widget version of a template
        if(isAdFree && !showIfAdFree) {
            return false; // skip widget area
        } else if((isAdFree || isAdLite) && !showIfAdLite) {
            return false; // skip widget area
        }

        if(blockDebug && blockCount > 0) console.log(blockCount + ') WIDGET TYPE: ' + widgetType);

        if(isAd) {
            widget = smiDfp.buildAdWrapper();

            $.each(widgetSettings.ads, function(i, v) {
                var adClass = (typeof v.class !== 'undefined' && v.class) ? v.class : null,
                    adStyle = (typeof v.style !== 'undefined' && v.style) ? v.style : null;

                ad = smiDfp.buildAd(v.view, adClass, adStyle);

                if($.isArray(v.size[0])) {
                    $.each(v.size, function(i2, sz) {
                        ad.addSize(sz[0], sz[1]);
                    });
                } else {
                    ad.addSize(v.size[0], v.size[1]);
                }

                if(typeof thisWidget.targeting !== 'undefined' && thisWidget.targeting) {
                    $.each(thisWidget.targeting, function(tKey, tValue) {
                        ad.addTargeting(tKey, tValue);
                    });
                }

                if(typeof thisWidget.show !== 'undefined') {
                    if(showIfAdFree) {
                        ad.setShowAdFree(true);
                    } else if(showIfAdLite) {
                        ad.setShowAdLite(true);
                    }
                }

                if(typeof thisWidget.delay !== 'undefined' && thisWidget.delay) {
                    ad.setDelay(thisWidget.delay);
                }

                ad.wrapWith(widget);
            });
        } else if(widgetType === 'widget') {
            widget = $('<div/>');
            if(widgetHeading) {
                $('<div/>', {
                    'class': 'dark-heading',
                    'html' : widgetHeading
                }).appendTo(widget);
            }
            widget.append(thisWidget.code);
        }
        return widget;
    }

    function fetchTemplate(name, callback) {
        if(fetchedTemplates.indexOf(name) !== -1)
            return callback.call();

        fetchedTemplates.push(name);

        var hasMap = $.grep(templateMap, function(e) {
            return e.id === name;
        });

        if(hasMap.length)
            return callback.call();

        callback.call();
        /*
                if(blockDebug) console.log('*** Fetching Template: (' + name + ')');

                $.get({
                    url: siteConfig.url.cdn + '/tpl2022/blocks/' + name + '.html'
                }).done(function(data) {
                    if(blockDebug) console.log('*** Template Fetched: (' + name + ')');
                    $('body').append(data);
                    callback.call();
                }).fail(function() {
                    if(blockDebug) console.error('*** Template Failed: (' + name + ')');
                    callback.call();
                });*
        */
    }

    function doBlock(block, blockData, onSuccess, onComplete) {
        blockCount++;
        if(blockDebug) console.log('*** Fetching Block (' + blockCount + ')');

        if(!block.length) return;
        if(!blockData.template) return;

        var tplName = blockData.template.toLowerCase(),
            tplBaseName = tplName.replace(/^nw-/, ''),
            tplId = '#tpl-' + tplName,
            is2022 = block.is('.tpl2022__build-block'),
            showWidget = !(!!blockData.hideWidget || (tplName.indexOf('nw-') === 0));

        fetchTemplate(tplBaseName, function() {
            var tplConfig = $.grep(templateMap, function(e) {
                return e.id === tplBaseName;
            });

            if(!$(tplId).length)
                tplId = '#tpl-' + tplBaseName;

            var templateWrap = !(blockData.path),
                localFeedExpire = 300, // in seconds
                widgets = [],
                widgetClass,
                hasParentWidget,
                forceShowWidget,
                widgetSide,
                req,
                url,
                params,
                storyData,
                layout,
                hasWidget,
                maxStories,
                deDupe,
                countDupe,
                startKey,
                cacheKey,
                heading,
                subheading;

            function successHandler(data) {
                var tpl = getTemplate(data),
                    tplHeader, tplStoryMap;

                if(tpl !== false) {
                    tpl = $(tpl);

                    tpl.addClass(widgetClass);
                    block.attr('data-cache-key', cacheKey).html(tpl);

                    tplHeader = block.find('.template-heading, .tpl2022__heading');
                    tplStoryMap = block.find('.has-size-map');

                    if(templateWrap)
                        tpl.addClass('tpl2022--is-wrapper');

                    if(block.closest('.tpl2022--is-wrapper').length)
                        block.addClass('tpl2022--is-wrapped');

                    if(tplHeader.length) {
                        if(heading) {
                            noHeadingCount = 0;
                            var headingTag = $('<span />', {html: heading});

                            if(is2022) {
                                tpl.addClass('tpl2022--has-heading');
                            } else {
                                tpl.addClass('has-heading');
                            }

                            if(data && typeof data.link !== 'undefined' && data.link.url) {
                                var target = data.link.target || '_self',
                                    aTag = $('<a />', {target: '_self', href: data.link.url, html: heading});
                                headingTag.html(aTag);
                            }

                            tplHeader.html(headingTag);
                            if(subheading) {
                                headingTag.append('&nbsp;&nbsp;<small>' + subheading + '</small>');
                            }
                        } else {
                            noHeadingCount++;

                            if(is2022) {
                                tpl.addClass('tpl2022--no-heading tpl2022--no-heading-' + noHeadingCount);
                            } else {
                                tpl.addClass('no-heading no-heading-' + noHeadingCount);
                            }

                            if(typeof layout.forceHeadSpace === 'undefined' || !layout.forceHeadSpace) {
                                tplHeader.remove();
                            }
                        }
                    }

                    if(tplStoryMap.length) {
                        $.each(tplStoryMap, function() {
                            var storyBlock = $(this),
                                breakpoints = storyBlock.data('size-map');
                            if(breakpoints !== 'undefined') {
                                resizeStories(storyBlock, breakpoints);
                                $(window).on('refactorLayout', function() {
                                    resizeStories(storyBlock, breakpoints);
                                });
                            }
                        });
                    }

                    setTimeout(function() {
                        widgetHandler();
                        adaptHeadlines(block);
                        adaptImages(block);

                        if($.isFunction(tplConfig.callbacks.success)) {
                            tplConfig.callbacks.success.call(block);
                        }
                        if(typeof blockData.onsuccess !== 'undefined' && $.isFunction(window[blockData.onsuccess])) {
                            window[blockData.onsuccess](block);
                        }
                        if($.isFunction(onSuccess)) {
                            onSuccess.call(block);
                        }

                        $(document).trigger('contentBlockLoaded', block);
                        block.trigger('contentBlockLoaded');
                    });
                }
            }

            function alwaysHandler() {
                if(tplConfig.length) {
                    if($.isFunction(tplConfig.callbacks.complete)) {
                        tplConfig.callbacks.complete.call(block);
                    }
                }

                if(typeof blockData.oncomplete !== 'undefined' && $.isFunction(window[blockData.oncomplete])) {
                    window[blockData.oncomplete](block);
                }

                if($.isFunction(onComplete)) {
                    onComplete.call(block);
                }
            }

            function buildWidgets() {
                if(tplConfig.length) {
                    tplConfig = tplConfig[0];

                    if(showWidget) {
                        var widget;
                        $.each(tplConfig.widgets, function(i, widgetSettings) {
                            widget = buildWidget(widgetSettings);
                            if(widget) widgets.push(widget);
                        });
                    }
                }
                return widgets.length;
            }

            function widgetHandler() {
                if(hasWidget) {
                    block.find('.widget-holder, .tpl2022__widget').each(function(i) {
                        $(this).html(widgets[i]);
                    });
                    if(block.find('.dfp-slot').length) {
                        smiDfp.loadAds(block);
                    }
                } else {
                    block.find('.has-widget').removeClass('has-widget').addClass('no-widget');
                    block.find('.tpl2022--has-widget').removeClass('tpl2022--has-widget').addClass('tpl2022--no-widget');
                }
            }

            function resizeStories(storyBlock, breakpoints) {
                $.each(breakpoints, function(i, v) {
                    if(window.matchMedia('(min-width: ' + i + 'px)').matches) {
                        storyBlock.removeClass().addClass('has-size-map').addClass(v);
                    }
                });
            }

            function getTemplate(data) {
                var ts = tplId, template;

                if(typeof loadedTemplates[ts] === 'undefined' && loadedTemplates[ts] !== false) {
                    template = $(ts);
                    if(template.length) {
                        loadedTemplates[ts] = Template7(template.html()).compile();
                    } else {
                        loadedTemplates[ts] = false;
                    }
                }

                if(loadedTemplates[ts]) {
                    if(templateWrap && !data) {
                        Template7.unregisterPartial('toBeWrapped');
                        Template7.registerPartial('toBeWrapped', block.html());
                        return loadedTemplates[ts]({hasWidget: !!hasWidget});
                    } else {
                        var stories = {};
                        if($.isArray(req.map)) {
                            $.each(req.map, function(i, v) {
                                stories[v.tArea] = stories[v.tArea] || [];
                                stories[v.tArea].push.apply(stories[v.tArea], data[v.area]);
                            });
                        } else {
                            stories.stories = data.stories;
                        }

                        stories.stories = filterStories(stories.stories);
                        if(!$.isEmptyObject(stories) && stories.stories.length && (stories.stories.length === maxStories || tplConfig.slots.requireAll === false)) {
                            stories.hasWidget = !!hasWidget;
                            return loadedTemplates[ts](stories);
                        }
                        if(blockDebug) console.error(blockCount + ') RENDERING FAILED: ' + stories.stories.length + ' of ' + maxStories + ' required stories');
                    }
                }

                return false;
            }

            function filterStories(stories) {
                var imgRequiredIn = tplConfig.slots.reqImageIn || [],
                    filteredStories = stories,
                    usedStories = [];

                if(!filteredStories || !filteredStories.length)
                    return false;

                if(deDupe) {
                    filteredStories = stories.filter(function(story) {
                        return $.inArray(story.cmsId, usedInPage) === -1;
                    });
                }

                // COMMENTED VERSION WAS SKIPPING STORIES DUE TO DE-DUPING ABOVE
                //filteredStories = filteredStories.slice(startKey, startKey + maxStories);

                // UNCOMMENTED VERSION WILL BREAK IF WE DON'T KEEP EACH CALL AS A CALLBACK OF THE PREVIOUS
                filteredStories = filteredStories.slice(0, maxStories);

                var i, storyCount = filteredStories.length;
                for(i = 0; i < storyCount; i++) {
                    var storyObj = shuffleForImageRequired(i);
                    if(storyObj && (typeof storyObj.cmsId !== 'undefined')) {
                        if(countDupe) usedInPage.push(storyObj.cmsId);
                        usedStories.push(storyObj);
                    }
                }

                if(typeof blockData.ref !== 'undefined' && blockData.ref.length) {
                    $.each(usedStories, function(i, v) {
                        v.href = updateQueryStringParameter('ref', blockData.ref, v.href);
                        usedStories[i] = v;
                    });
                }

                return usedStories;

                function shuffleForImageRequired(iteration, trialCount) {
                    if(!trialCount) trialCount = 0;
                    var storyObj = filteredStories[0];

                    if(storyObj && (typeof storyObj.image.thumb !== 'undefined')) {
                        if($.inArray(iteration, imgRequiredIn) !== -1 && !storyObj.image.thumb) {
                            trialCount = (trialCount + 1);
                            if(trialCount < filteredStories.length) {
                                filteredStories.splice(0, 0, filteredStories.splice(trialCount, 1)[0]);
                                return shuffleForImageRequired(iteration, trialCount);
                            }
                        }
                    }

                    return filteredStories.shift();
                }
            }

            if(!tplConfig.length) {
                console.error(blockCount + ') NO CONFIG:   ' + tplId);
                alwaysHandler();
                return;
            }

            if(blockDebug) console.log(blockCount + ') TEMPLATE:    ' + tplId);

            if(!templateWrap) {
                req = getRoute(blockData.path);
                url = req.url;
                params = req.params;
                storyData = req.data;
                if(blockDebug) console.log(blockCount + ') URL:         ' + url);
            }

            hasWidget = buildWidgets();
            hasParentWidget = block.closest('.has-widget, .tpl2022--has-widget').length;
            tplConfig.slots = tplConfig.slots || {};
            tplConfig.callbacks = tplConfig.callbacks || {};
            maxStories = tplConfig.slots.hasWidget || 0;
            deDupe = typeof tplConfig.slots.deDupe !== 'undefined' ? !!tplConfig.slots.deDupe : (typeof blockData.dedupe !== 'undefined' ? !!blockData.dedupe : true);
            countDupe = typeof tplConfig.slots.countDupe !== 'undefined' ? !!tplConfig.slots.countDupe : (typeof blockData.countdupe !== 'undefined' ? !!blockData.countdupe : deDupe);
            heading = blockData.heading || false;
            subheading = blockData.subheading || false;

            layout = tplConfig.layout || {};
            forceShowWidget = typeof layout.forceShow !== 'undefined' && layout.forceShow;

            widgetClass = is2022 ? 'tpl2022--no-widget' : 'no-widget';
            // check if there is a widget available or, if child, parent has a widget or widget definition says to include widget area
            if(is2022 && (hasWidget || hasParentWidget)) {
                if(typeof layout.widgetCol === 'string') {
                    widgetSide = layout.widgetCol;
                    if(typeof ad === 'object') {
                        if(layout.widgetCol === 'auto') {
                            widgetSide = widgetRight ? 'right' : 'left';
                            widgetRight = !widgetRight;
                        }
                    } else {
                        widgetSide = 'right';
                    }

                    widgetClass = 'tpl2022--has-widget tpl2022--has-widget-' + widgetSide;
                }
            } else if(hasWidget || hasParentWidget || forceShowWidget) {
                if(typeof layout.widgetCol !== 'undefined' && layout.breakAt !== 'undefined') {
                    widgetSide = layout.widgetCol;
                    if(typeof ad === 'object') {
                        if(layout.widgetCol === 'auto') {
                            widgetSide = widgetRight ? 'right' : 'left';
                            widgetRight = !widgetRight;
                        }
                    } else {
                        widgetSide = 'right';
                    }

                    widgetClass = 'has-widget widget-' + widgetSide + '-' + layout.breakAt;
                }
            } else {
                var tplIdTemp = '#tpl-nw-' + tplBaseName;
                if($(tplIdTemp).length) tplId = tplIdTemp;
                maxStories = parseInt(tplConfig.slots.noWidget || 0);
                hasWidget = false;
            }

            maxStories = (typeof blockData.maxStories !== 'undefined') ? blockData.maxStories : maxStories;

            if(heading === prevHeading) heading = false;
            else prevHeading = heading;

            if(!templateWrap)
                localFeedExpire = 0;

            if(templateWrap) {

                if(blockDebug) console.log(blockCount + ') DATA FROM:   n/a');
                successHandler();
                alwaysHandler();
                return true;

            } else {

                cacheKey = hashedUrl(url, params);
                startKey = 0;
                if(deDupe) {
                    if(!$.isArray(storyCounts[cacheKey])) storyCounts[cacheKey] = [];
                    startKey = storyCounts[cacheKey].reduce(function(acc, val) {
                        return acc + val;
                    }, 0);
                    storyCounts[cacheKey][blockCount] = maxStories;
                    feedPointer[cacheKey] = startKey + maxStories;
                }

                if(typeof feeds[cacheKey] === 'object') {
                    var feedData = feeds[cacheKey];
                    if(blockDebug) console.log(blockCount + ') DATA FROM:   feed in memory');
                    successHandler(feedData);
                    alwaysHandler();
                    return true;
                }

                if(storyData) {

                    if(blockDebug) console.log(blockCount + ') DATA FROM:   on page variable');
                    feeds[cacheKey] = storyData;
                    successHandler(storyData);
                    alwaysHandler();
                    return true;

                } else {

                    try {
                        if(sessionStorage) {
                            var cached = sessionStorage.getItem(cacheKey),
                                whenCached = sessionStorage.getItem(cacheKey + ':ts');

                            if(cached !== null && whenCached !== null) {
                                var age = (Date.now() - whenCached) / 1000;
                                if(age < localFeedExpire) {
                                    var data = JSON.parse(cached);
                                    if(typeof data === 'object') {
                                        if(blockDebug) console.log(blockCount + ') DATA FROM:   session storage');
                                        feeds[cacheKey] = data;
                                        successHandler(data);
                                        alwaysHandler();
                                        return true;
                                    }
                                } else {
                                    sessionStorage.removeItem(cacheKey);
                                    sessionStorage.removeItem(cacheKey + ':ts');
                                }
                            }
                        }
                    } catch(e) {
                        $.noop();
                    }

                    if(url.indexOf('http') !== -1) {
                        $.ajax({
                            dataType: 'json',
                            url     : url,
                            data    : params,
                            timeout : 6000
                        }).done(function(data) {
                            feeds[cacheKey] = data;
                            try {
                                if(sessionStorage) {
                                    sessionStorage.setItem(cacheKey, JSON.stringify(data));
                                    sessionStorage.setItem(cacheKey + ':ts', Date.now());
                                }
                            } catch(e) {
                                try {
                                    if(sessionStorage) {
                                        sessionStorage.clear();
                                    }
                                } catch(e) {
                                    $.noop();
                                }
                            }
                            if(blockDebug) console.log(blockCount + ') DATA FROM:   $.getJSON()');
                            successHandler(data);
                        }).always(function() {
                            alwaysHandler();
                        }).fail(function() {
                            if(blockDebug) {
                                console.error(blockCount + ') JSON ERROR: failed to fetch ' + url);
                            }
                        });
                    } else {
                        console.error(blockCount + ') DATA ERROR: no way to fetch data for ' + url + '. It may be empty or it may not exist.');

                        alwaysHandler();
                    }
                }
            }
        });
    }

    function getRoute(feedPath) {
        var feedUrl, feedParams = {};

        if(feedPath.indexOf('/') === -1) {
            return {
                url   : feedPath, // used to create key for cached feed
                params: feedPath, // used to create key for cached feed
                map   : null,
                data  : window[feedPath]
            };
        }

        feedPath = feedPath.toLowerCase().replace(/^\/+|\/+$/g, '');
        feedUrl = 'https://feeds.' + feedDomain + '/' + feedDir + '/' + feedPath + '.json';
        feedParams.v = '20210824';

        return {
            url   : feedUrl,
            params: feedParams,
            map   : null,
            data  : null
        };
    }

    function hashedUrl(url, params) {
        var hash = 0, qs = '', i;
        if(params && (typeof params === 'object'))
            qs = '?' + decodeURIComponent($.param(params));
        url = url + qs;

        if(url.length === 0) return hash;
        for(i = 0; i < url.length; i++) {
            var char = url.charCodeAt(i);
            hash = ((hash<<5) - hash) + char;
            hash = hash&hash;
        }
        return hash;
    }

    function isAboveBottomOfViewport(el) {
        el = (typeof el === 'string' || el instanceof String) ? $(el) : el;
        var elementTop = el.offset().top,
            viewportBottom = $(window).scrollTop() + $(window).height();
        return elementTop < viewportBottom;
    }

    function updateQueryStringParameter(key, value, url) {
        if(!url) url = window.location.href;

        var i = url.indexOf('#');
        var hash = i === -1 ? '' : url.substr(i);
        url = i === -1 ? url : url.substr(0, i);

        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        var separator = url.indexOf('?') !== -1 ? '&' : '?';
        if(value === false) { // added if(value === false) as a means to remove a parameter by setting cphGlobal.updateQueryStringParameter("key",
            // false)
            if(url.match(re)) {
                url = url.replace(re, '$1');
            }
        } else {
            if(url.match(re)) {
                url = url.replace(re, '$1' + key + '=' + value + '$2');
            } else {
                url = url + separator + key + '=' + value;
            }
        }
        url = url.replace(/([\?\&]+)$/, ''); // added to remove ? or & at end of url if present
        return url + hash;
    }

    $(document).on('ajaxStart.contentLoader', function() {
        var asInt = setInterval(function() {
            if(!$.active) {
                $(document).off('ajaxStart.contentLoader');
                clearInterval(asInt);
                setTimeout(function() {
                    //adaptStories();
                    adaptAllHeadlines();
                    adaptImages();
                    $(window).trigger('jsonLoaded');
                }, 250);
            }
        }, 150);
    });

    var resizeTimer; // debounced
    $(window).on('resize orientationchange', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            $(window).trigger('refactorLayout');
            //adaptStories();
            adaptAllHeadlines();
            adaptImages();
        }, 250);
    });

    var wait; // throttled
    $(window).on('scroll', function() {
        if(!wait) {
            wait = true;
            setTimeout(function() {
                wait = false;
                adaptImages();
            }, 250);
        }
    });

    // to load standalone widgets (not within a blockloaded template)
    /*$('.manual-widget').each(function() {
        var widgetContainer = $(this),
            thisWidgetArray = widgetContainer.data('widget-array');

        if(thisWidgetArray && typeof window[thisWidgetArray] !== 'undefined' && window[thisWidgetArray].length) {
            widgetArray = window[thisWidgetArray];
        }

        var widgetSize = widgetContainer.data('size'),
            widgetSettings = {}, adSize;

        if(widgetSize === 'cube') {
            adSize = [300, 250];
        } else if(widgetSize === 'half') {
            adSize = [300, 600];
        } else if(widgetSize === 'leaderboard' || widgetSize === 'banner') {
            adSize = [728, 90];
        }

        widgetSettings.size = widgetSize;
        widgetSettings.ads = [];
        widgetSettings.ads.push({
            view : widgetContainer.data('show'),
            size : adSize,
            style: widgetContainer.data('style')
        });

        var widget = buildWidget(widgetSettings);
        if(widget) widgetContainer.html(widget).addClass(widgetContainer.data('class'));
    });*/
});